import { json } from "@remix-run/cloudflare";
import type {
  HeadersFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import clsx from "clsx";
import { createSbClientSSR } from "~/utils/createSbClientSSR";
import { PostService } from "~/database/post.service";

import PostItem from "~/components/Post/PostItem";
import { Pagination } from "~/components/Post/Pagination";
import {
  DEFAULT_DESCRIPTION,
  PR_COLORS,
  TITLE_SUFFIX,
} from "~/utils/const";

export const meta: MetaFunction = () => {
  return [
    { title: "New Post" + TITLE_SUFFIX },
    {
      name: "description",
      content: DEFAULT_DESCRIPTION,
    },
  ];
};

export const headers: HeadersFunction = ({
  loaderHeaders,
}) => ({
  "op-cache-status":
    loaderHeaders.get("op-cache-status") ??
    "MISS",
});

const PER_PAGE = 12;
export const loader = async ({
  context,
  request,
  params,
}: LoaderFunctionArgs) => {
  const headers = new Headers();
  // queryParamerte

  const supabase = createSbClientSSR(
    headers,
    request,
    context,
  );
  try {
    const url = new URL(request.url);
    console.log("params.page:", params.page);
    const page = Number(
      url.searchParams.get("page"),
    );
    const postData =
      await PostService.getPostPagination(
        supabase,
        {
          limit: PER_PAGE,
          page: page || 1,
        },
      );
    return json(
      {
        postData: postData,
      },

      {
        headers: headers,
      },
    );
  } catch (_e) {
    const e = _e as Error;
    console.log("e:", e);
    if (e.message === "Post not found") {
      // 404
      throw new Response(null, {
        status: 404,
        statusText: "Not Found",
      });
    } else if (
      e.message === "DB Access Error" ||
      e.message === "VAlidationError"
    ) {
      // 500
      throw new Response(null, {
        status: 500,
        statusText: "Server Error",
      });
    } else {
      throw new Response(null, {
        status: 500,
        statusText: "Server Error Unknown",
      });
    }
  }
};

export default function Index() {
  const { postData } =
    useLoaderData<typeof loader>();
  const {
    posts,
    totalPosts,
    currentPage,
    postsPerPage,
  } = postData;
  return (
    <div
      className={clsx(
        "pb-128 pt-80 text-black",
        "max-md:pt-110",
        "max-md:pb-0",
      )}
    >
      <h1
        className={clsx(
          "text-center",
          "text-28",
          "font-bold",
        )}
      >
        New Post
      </h1>
      <ul
        className={clsx(
          "grid",
          "grid-cols-3",
          "gap-16",
          "mt-40",
          "w-1300",
          "mx-auto",
          "gap-40",

          "max-md:flex",
          "max-md:flex-col",
          "max-md:gap-30",
          "max-md:w-360",
          "max-md:mr-0",
        )}
      >
        {posts.map((el, i) => {
          return (
            <li key={i} className={clsx("")}>
              <PostItem
                data={el}
                color={
                  PR_COLORS[i % PR_COLORS.length]
                }
              ></PostItem>
            </li>
          );
        })}
      </ul>
      <div className={clsx("mt-60")}>
        <Pagination
          totalPosts={totalPosts}
          currentPage={currentPage}
          postsPerPage={postsPerPage}
          urlBase={"/new"}
        />
      </div>
    </div>
  );
}
